// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'paper-search';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M2.813 5.063h7.874M2.813 8.438h2.812m-2.812 3.375h2.812m0 3.375H1.687a1.125 1.125 0 0 1-1.125-1.126V1.688A1.125 1.125 0 0 1 1.688.563H9.66c.298 0 .584.118.795.329l2.154 2.154c.211.21.33.497.33.795v1.784' />
    <path d='M7.886 11.813a3.937 3.937 0 1 0 7.874 0 3.937 3.937 0 0 0-7.874 0zm9.552 5.624-2.83-2.84' />
  </g>
);

export const viewBox = '0 0 18 18';
